import React from "react";
import { useParams } from "react-router-dom";

const Title = ( props ) => {

  const params = useParams();

  return (
    <h1 className="tit left">
      { props.children && `${ props.children } ` }
      { props.children && <span className="code-num">{ params.stageCode }</span> }
    </h1>
  );

};

export default Title;
